import appConfig from '../../../config/appConfig';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {TobaccoIcon, UsageBlueIcon} from '../../Icons';

const LEVIA_LEARN_MORE_DATA = [
    {
        icon: UsageBlueIcon,
        titleKey: localizationKeys.LEVIA_LEARN_MORE_ABOUT_ITEM_1,
    },
    {
        icon: TobaccoIcon,
        titleKey: localizationKeys.LEVIA_LEARN_MORE_ABOUT_ITEM_2,
    },
];

const getLeviaLearnMoreData = () => {
    const configIcons = appConfig.getLeviaConsumablesIcons();
    const isAnyIcon = configIcons?.length;

    if (isAnyIcon) {
        return configIcons.map((icon, i) => ({
            titleKey: LEVIA_LEARN_MORE_DATA[i]?.titleKey,
            iconPath: appConfig.getCombinedPathAssetPath(icon),
        }));
    }

    return LEVIA_LEARN_MORE_DATA;
};

export {getLeviaLearnMoreData};
